<template>
  <div v-if="hasAlertsData">
    <div class="asc-analytic-form-alerts-table">
      <table
        border="1"
        frame="void"
        rules="rows"
        class="asc-analytic-form-alerts-table--table"
      >
        <thead>
          <tr class="top-header">
            <th
              v-for="(header, rIndex) in alertsDefinition.headings"
              :key="rIndex"
              scope="col"
              class="asc-analytic-form-alerts-table--th"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in alertsDefinition.values" :key="index">
            <td class="asc-analytic-form-alerts-table--td">
              <div class="asc-analytic-form-alerts-table--td-alertName">
                {{ row.alertKey }}
              </div>
            </td>
            <td class="asc-analytic-form-alerts-table--td">
              <textarea
                class="asc-analytic-form-alerts-table--td-alertName"
                spellcheck="false"
                :value="row.name"
                maxlength="255"
                @input="updateAlertsName(index, $event.target.value)"
              ></textarea>
              <v-icon
                :size="16"
                :color="getColor"
                class="asc-analytic-form-alerts-table--td-icon"
                >edit</v-icon
              >
            </td>
            <td class="asc-analytic-form-alerts-table--td--component">
              <asc-autocomplete-selector
                class="componentsDropdown"
                :value="getAlertsComponents(index)"
                :items="componentsOptions"
                short
                @input="updateAlertsComponents(index, ...arguments)"
              ></asc-autocomplete-selector>
            </td>
            <td class="asc-analytic-form-alerts-table--td--airlines">
              <asc-autocomplete-selector
                :value="getAlertsAirlines(index)"
                :items="airlinesOptions"
                display-clear
                short
                component-type="multiple"
                @input="updateAlertsAirlines(index, ...arguments)"
              ></asc-autocomplete-selector>
            </td>
            <td class="asc-analytic-form-alerts-table--td--airlines">
              <asc-autocomplete-selector
                :value="getAlertsIssues(index)"
                :items="issueTypes"
                display-clear
                short
                component-type="multiple"
                @input="updateAlertsIssues(index, ...arguments)"
              ></asc-autocomplete-selector>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AscAutocompleteSelector from './AscAutocompleteSelector'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscAnalyticAlertsTable',

  components: {
    AscAutocompleteSelector,
  },

  props: {
    components: {
      type: Array,
      required: true,
      default: () => [],
    },
    airlines: {
      type: Array,
      required: true,
      default: () => [],
    },
    alertTypes: {
      type: Array,
      default: () => [],
    },
    issueTypes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      alertsDefinition: {
        headings: [
          'Analytic Name',
          'Analytic Display Name',
          'Component',
          'Enabled for?',
          'Issue Type',
        ],
        values: this.alertTypes,
      },
    }
  },

  computed: {
    getColor() {
      return variables.gray600
    },
    componentsOptions() {
      if (this.components) {
        const duplicateSysName = []
        const duplicates = this.components
          .filter((item, index, array) => {
            const c = array.map(item => item.name)
            const i = array.findIndex(
              val =>
                val.name === item.name && val.systemName === item.systemName,
            )
            if (i >= 0 && i !== index) {
              duplicateSysName.push(item.name)
            }
            return index !== c.indexOf(item.name)
          })
          .map(item => item.name)
        return this.components.map(function (item) {
          let compName = item.name
          if (
            duplicates.includes(item.name) &&
            !duplicateSysName.includes(item.name)
          ) {
            compName = item.name + ` (${item.systemName})`
          } else if (
            duplicates.includes(item.name) &&
            duplicateSysName.includes(item.name)
          ) {
            compName = item.name + ` (${item.systemName} - ${item.id})`
          }
          return {
            text: compName,
            value: item.id,
          }
        })
      }
      return []
    },
    airlinesOptions() {
      if (this.airlines) {
        return this.airlines.map(item => ({
          text: item.name,
          value: item.id,
        }))
      }
      return []
    },
    hasAlertsData() {
      return (
        this.alertsDefinition.values !== undefined &&
        this.alertsDefinition.values.length > 0
      )
    },
  },

  methods: {
    getAlertsName(index) {
      return this.alertTypes[index].name
    },
    getAlertsComponents(index) {
      return this.alertTypes[index].primaryComponentId
    },
    getAlertsAirlines(index) {
      return this.alertTypes[index].airlineIds
    },
    getAlertsIssues(index) {
      return this.alertTypes[index].issueTypeIds
    },
    updateAlertsIssues(index, model) {
      const newData = {
        alert: {
          ...this.alertTypes[index],
          issueTypeIds: model,
        },
        index: index,
      }

      this.$emit('update-alert', newData)
    },
    updateAlertsAirlines(index, model) {
      const newData = {
        alert: {
          ...this.alertTypes[index],
          airlineIds: model,
        },
        index: index,
      }
      this.$emit('update-alert', newData)
    },
    updateAlertsComponents(index, model) {
      const newData = {
        alert: {
          ...this.alertTypes[index],
          primaryComponentId: model[0] ? model[0] : 0,
        },
        index: index,
      }
      this.$emit('update-alert', newData)
    },
    updateAlertsName(index, value) {
      const newData = {
        alert: {
          ...this.alertTypes[index],
          name: value,
        },
        index: index,
      }
      this.$emit('update-alert', newData)
    },
  },
}
</script>

<style lang="scss">
.asc-analytic-form-alerts-table {
  max-width: 990px;

  &--table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    text-align: left;
    border: 1px solid $gray-400;
  }

  &--td {
    border: 0;
    font-size: $font-size-sm;
    max-width: 200px;

    &--airlines {
      border: 0;
      padding: 5px;
      max-width: 180px;
      min-width: 120px;
    }

    &--component {
      border: 0;
      padding: 5px;
      max-width: 120px;
    }

    &-alertName {
      font-size: 12px;
      height: 45px;
      resize: none;
      padding: 3px;
      width: 200px;

      &:focus {
        outline: 2px solid $accent-600;
      }
    }

    &-icon {
      float: left;
      display: none !important;
      padding: 0;
    }
  }

  &--th {
    padding: 0.5em;
    font-size: $font-size-sm;
    background-color: $gray-300;
    font-weight: normal;
    border-collapse: collapse;
  }
}

// prettier-ignore
.asc-analytic-form-alerts-table--td-alertName:hover + .asc-analytic-form-alerts-table--td-icon {
  display: inline-block !important;
}
</style>
